import { BaseEditor, Editor, Transforms } from "slate";
import { ReactEditor } from "slate-react";
import { CustomElement } from "../slate";
import { ImageSizeUrl } from "../components/image-prompt.component";

export interface ImagesEditor extends BaseEditor {
  isImage: () => boolean;
  insertImage: (urls: ImageSizeUrl) => void;
}

const isImage = (editor: Editor) => {
  const [match] = Editor.nodes(editor, {
    match: (n: CustomElement | any) => n.type === "image",
  });
  return !!match;
};

const insertImage = (editor: Editor, urls: ImageSizeUrl) => {
  Transforms.insertFragment(
    editor,
    [
      {
        type: "image",
        desktopUrl: urls.desktop,
        mobileUrl: urls.mobile,
        rawUrl: urls.raw,
        children: [],
      },
      { type: "paragraph", children: [{ text: "" }] },
    ],
    { voids: true, hanging: true }
  );
  ReactEditor.focus(editor);
};

export const withImages = (editor: Editor) => {
  const { isVoid } = editor;

  editor.isVoid = (element: CustomElement) => {
    return element.type === "image" ? true : isVoid(element);
  };

  editor.isImage = () => isImage(editor);
  editor.insertImage = (urls: ImageSizeUrl) => insertImage(editor, urls);
  return editor;
};
